import CdnResourceResolverService from "./CdnResourceResolverService";

class ModuleLogoLinkProviderClass {
    pattern = 'module-logo';
    allowedProperties = ['reverse'];

    transform(moduleKey, extension, properties = [], pattern = this.pattern) {
        const parameters = {extension: extension};
        parameters.denomination = moduleKey;
        if (properties.length) parameters.properties = properties.filter(p => this.allowedProperties.includes(p))
                                                                 .sort()
                                                                 .map(p => '-' + p)
                                                                 .join('');
        return CdnResourceResolverService.getResource(pattern, parameters);
    }
}

let ModuleLogoLinkProvider = new ModuleLogoLinkProviderClass();
export default ModuleLogoLinkProvider;



// WEBPACK FOOTER //
// ./services/ModuleLogoLinkProvider.js